import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import { MENU_LOAD_DATA, ASYNC_MENU_LOAD_DATA } from 'store';

function* menuLoadData() {
  const response = yield call(api.get, 'menus');

  const payload = yield response.data;

  yield put({
    type: MENU_LOAD_DATA,
    payload
  });
}

export default function* root() {
  yield all([takeLatest(ASYNC_MENU_LOAD_DATA, menuLoadData)]);
}
